import React, { useEffect } from 'react';
import { Typography, Row, Col, Divider } from 'antd';
import '../../Styles/ResearchLabs.css';  
import AppHeader from '../../Layout/Header';
import FooterComponent from '../../Layout/Footer';
import uoalogo from '../../Assets/ResearchLabs/ARSL/UOA.jpeg'; 
import arslbanner from '../../Assets/ResearchLabs/ARSL/arslbanner.jpg';
import arslhost from '../../Assets/ResearchLabs/ARSL/arslhost.jpg';

import ArslScope from './ARSL Components/ArslScope';
import ArslDomain from './ARSL Components/ArslDomain';
import Impact from './ARSL Components/Impact';
import ArslHead from './ARSL Components/ArslHead';
import SocialFeed from './ARSL Components/SocialFeed';

const { Title } = Typography;

const AgriculturalRemoteSensingLab = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);
    return (
        <>
            <AppHeader />
            <main className="individual-lab-page">
            {/* Header Section */}
            <div className="spatial-lab-section" 
                style={{ backgroundImage: `url(${arslbanner})` }}

            >
                
            </div>

            {/* Host University Section */}
                        <section className="sarl-host-section">

                <div className="sarl-host-inner">

                    <Row
                        gutter={[72, 40]}
                        align="middle"
                        justify="space-between"
                    >

                        {/* University Information */}

                        <Col xs={24} md={11}>

                            <Title
                                level={2}
                                className="sarl-host-title"
                            >
                                Host University
                            </Title>

                            <Divider className="ncgsa-divider" />

                            <div className="sarl-host-identity">

                                <img
                                    src={uoalogo}
                                    alt="University of Agriculture, Faisalabad logo"
                                    className="sarl-host-logo"
                                />

                                <Title
                                    level={5}
                                    className="sarl-host-name"
                                >
                                    University of Agriculture, Faisalabad
                                </Title>

                            </div>

                        </Col>


                        {/* University campus */}

                        <Col xs={24} md={10}>

                            <img
                                src={arslhost}
                                alt="University of Agriculture, Faisalabad campus"
                                className="sarl-host-campus"
                            />

                        </Col>

                    </Row>

                </div>

            </section>
            <ArslScope />
            <ArslDomain />
            <Impact />
            <ArslHead />
            <SocialFeed/>
            </main>
            <FooterComponent />
        </>
    );
};

export default AgriculturalRemoteSensingLab;
